// import React from "react";

// const NLPComponent = () => {
//   return (
//     <div style={styles.container}>
//       {/* Right Side (Image) */}
//       <div style={styles.rightSide}>
//         <div style={styles.imageContainer}>
//           <img
//             src="/image/nllp.jpg"
//             alt="NLP Representation"
//             style={styles.image}
//           />
//         </div>
//       </div>

//       {/* Left Side (Text Content) */}
//       <div style={styles.leftSide}>
//         <h2 style={styles.header}>The Power of NLP</h2>
//         <p style={styles.paragraph}>
//           Natural Language Processing (NLP) bridges the gap between human
//           communication and computer understanding. It enables businesses to
//           analyze, interpret, and generate human language in ways that enhance
//           customer experience and operational efficiency.
//         </p>
//         <ul style={styles.list}>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span> Sentiment Analysis for Customer
//             Insights
//           </li>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span> Intelligent Chatbots & Virtual
//             Assistants
//           </li>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span> Text Summarization & Information
//             Extraction
//           </li>
//           <li style={styles.listItem}>
//             <span style={styles.arrow}>➔</span> Multilingual Translation &
//             Speech Recognition
//           </li>
//         </ul>
//       </div>
//     </div>
//   );
// };

// // Responsive styles using JS
// const styles = {
//   container: {
//     display: "flex",
//     flexWrap: "wrap",
//     justifyContent: "center",
//     alignItems: "center",
//     padding: "2rem",
//     backgroundColor: "#025261",
//     color: "#fff",
//   },
//   leftSide: {
//     flex: "1 1 400px",
//     padding: "1rem",
//     display: "flex",
//     flexDirection: "column",
//     justifyContent: "center",
//   },
//   header: {
//     fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
//     fontWeight: "bold",
//     color: "white",
//     marginBottom: "1rem",
//   },
//   paragraph: {
//     fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
//     margin: "1rem 0",
//     textAlign: "justify",
//     lineHeight: "1.6",
//   },
//   list: {
//     listStyleType: "none",
//     paddingLeft: 0,
//   },
//   listItem: {
//     fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
//     marginBottom: "0.7rem",
//     display: "flex",
//     alignItems: "center",
//   },
//   arrow: {
//     marginRight: "0.6rem",
//     color: "#4CAF50",
//     fontSize: "1.2rem",
//   },
//   rightSide: {
//     flex: "1 1 400px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     marginTop: "1rem",
//   },
//   imageContainer: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     width: "100%",
//   },
//   image: {
//     width: "100%",
//     maxWidth: "550px",
//     height: "auto",
//     borderRadius: "8px",
//   },
// };

// export default NLPComponent;



import React from "react";
import { motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const NLPComponent = () => {
  const { ref, inView } = useInView({
    triggerOnce: true, // animate only once
    threshold: 0.2, // % of component visible before animation starts
  });

  // Animation variants
  const textVariant = {
    hidden: { opacity: 0, y: 40 },
    visible: (i) => ({
      opacity: 1,
      y: 0,
      transition: { delay: i * 0.3, duration: 0.6, ease: "easeOut" },
    }),
  };

  const points = [
    "Sentiment Analysis for Customer Insights",
    "Intelligent Chatbots & Virtual Assistants",
    "Text Summarization & Information Extraction",
    "Multilingual Translation & Speech Recognition",
  ];

  return (
    <div style={styles.container} ref={ref}>
      {/* Right Side (Image) */}
      <div style={styles.rightSide}>
        <div style={styles.imageContainer}>
          <img
            src="/image/nllp.jpg"
            alt="NLP Representation"
            style={styles.image}
          />
        </div>
      </div>

      {/* Left Side (Text Content) */}
      <div style={styles.leftSide}>
        <motion.h2
          style={styles.header}
          variants={textVariant}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          custom={0}
        >
          The Power of NLP
        </motion.h2>

        <motion.p
          style={styles.paragraph}
          variants={textVariant}
          initial="hidden"
          animate={inView ? "visible" : "hidden"}
          custom={1}
        >
          Natural Language Processing (NLP) bridges the gap between human
          communication and computer understanding. It enables businesses to
          analyze, interpret, and generate human language in ways that enhance
          customer experience and operational efficiency.
        </motion.p>

        <ul style={styles.list}>
          {points.map((point, i) => (
            <motion.li
              key={i}
              style={styles.listItem}
              variants={textVariant}
              initial="hidden"
              animate={inView ? "visible" : "hidden"}
              custom={i + 2}
            >
              <span style={styles.arrow}>➔</span> {point}
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  );
};

// Responsive styles using JS
const styles = {
  container: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    padding: "2rem",
    backgroundColor: "#025261",
    color: "#fff",
  },
  leftSide: {
    flex: "1 1 400px",
    padding: "1rem",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  header: {
    fontSize: "clamp(1.5rem, 4vw, 2.5rem)",
    fontWeight: "bold",
    color: "white",
    marginBottom: "1rem",
  },
  paragraph: {
    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
    margin: "1rem 0",
    textAlign: "justify",
    lineHeight: "1.6",
  },
  list: {
    listStyleType: "none",
    paddingLeft: 0,
  },
  listItem: {
    fontSize: "clamp(0.9rem, 2.5vw, 1.1rem)",
    marginBottom: "0.7rem",
    display: "flex",
    alignItems: "center",
  },
  arrow: {
    marginRight: "0.6rem",
    color: "#4CAF50",
    fontSize: "1.2rem",
  },
  rightSide: {
    flex: "1 1 400px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginTop: "1rem",
  },
  imageContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
  },
  image: {
    width: "100%",
    maxWidth: "550px",
    height: "auto",
    borderRadius: "8px",
  },
};

export default NLPComponent;
